// Opens a Heres chatbot flow when a user clicks a CTA whose link points to one
// of the sentinel hashes below, instead of navigating. Wire a CTA by setting
// its link/href to the matching hash (e.g. "#store-locator").
(function () {
  var MESSAGES = {
    '#sleep-quiz': '@@SLEEP-QUIZ',
    '#shop-assistant': '@@SHOP-ASSISTANT',
    '#store-locator': '@@STORE-LOCATOR'
  };

  function matchTrigger(target) {
    var link = target.closest && target.closest('a[href]');
    if (!link) return null;
    var href = link.getAttribute('href') || '';
    var keys = Object.keys(MESSAGES);
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      if (href === key || href.slice(-key.length) === key) {
        return MESSAGES[key];
      }
    }
    return null;
  }

  document.addEventListener('click', function (e) {
    var code = matchTrigger(e.target);
    if (!code) return;
    e.preventDefault();
    if (window.heres && typeof window.heres.sendMessage === 'function') {
      window.heres.sendMessage(code, { display: false });
    } else {
      console.warn('[heres] chatbot not available for', code);
    }
  });
})();
